"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var executeCode = function executeCode(_ref) {
  var area = _ref.area,
      code = _ref.code,
      id = _ref.id,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === void 0 ? true : _ref$wrapper;
  if (!id || !code) return;
  var scriptString = code;

  if (wrapper) {
    scriptString = "<div id=\"mco-tracking--".concat(id, "\">").concat(code, "</div>");
  }

  var range = document.createRange();
  var appendElement = null;

  if (area === "body" || area === "footer") {
    appendElement = document.getElementsByTagName("BODY")[0];
  } else {
    appendElement = document.getElementsByTagName("HEAD")[0];
  }

  range.selectNode(appendElement);
  appendElement.appendChild(range.createContextualFragment(scriptString));
};

var _default = executeCode;
exports.default = _default;